import { render } from "./MigrateData.vue?vue&type=template&id=77bf9a91&scoped=true"
import script from "./MigrateData.vue?vue&type=script&lang=js"
export * from "./MigrateData.vue?vue&type=script&lang=js"

import "./MigrateData.vue?vue&type=style&index=0&id=77bf9a91&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77bf9a91"]])

export default __exports__